import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

interface EmailAliasConfirmationData {
  originalEmail: string;
  accountEmail: string;
  alias: string;
  emailEditable: boolean;
  fromConsentRequest: boolean;
}

@Component({
  selector: 'app-email-alias-confirmation-dialog',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule],
  template: `
    <h2 mat-dialog-title>Email alias will be removed</h2>
    <mat-dialog-content>
      <p>
        @if (data.emailEditable) {
          You entered <strong>{{ data.originalEmail }}</strong>.
        } @else if (data.fromConsentRequest) {
          The email provided with your consent request is <strong>{{ data.originalEmail }}</strong>.
        } @else {
          Your signup email is <strong>{{ data.originalEmail }}</strong>.
        }
        Your account will use <strong>{{ data.accountEmail }}</strong> because the
        <strong>{{ data.alias }}</strong> part is removed during signup.
      </p>
      @if (!data.emailEditable) {
        <p>You can't change this email on this page.</p>
      }
      <p>Do you want to continue with <strong>{{ data.accountEmail }}</strong>?</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="dialogRef.close(data.emailEditable ? 'edit' : 'cancel')">
        {{ data.emailEditable ? 'Edit email' : 'Cancel' }}
      </button>
      <button mat-flat-button color="primary" type="button" (click)="dialogRef.close('continue')">
        Continue with {{ data.accountEmail }}
      </button>
    </mat-dialog-actions>
  `,
})
export class EmailAliasConfirmationDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: EmailAliasConfirmationData,
    public dialogRef: MatDialogRef<EmailAliasConfirmationDialogComponent>,
  ) {}
}
